import React, { Component } from 'react';
import { addScenario } from './UserFunctions'
import PopupModal from './PopupModal.js'
import './menuIcon.css'
class AddScenario extends Component{
    constructor(props){
        super(props)
        this.state ={
            scenario_group_name : "",
            scenario_id : [],
            scenario_uuid : [""],
            sequence_no : [],
            showpopup : false,
            status : "",
            count : 0,
            rows : [{scene_id : "", scene_uuid:"", seq_id:""}]
        }
        this.onScenarioGroupNameChange = this.onScenarioGroupNameChange.bind(this)
        this.onScenarioIdChange = this.onScenarioIdChange.bind(this)
        this.onScenarioUuidChange = this.onScenarioUuidChange.bind(this)
        this.onSequenceNoChange = this.onSequenceNoChange.bind(this)
        this.onSubmiting = this.onSubmiting.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
        this.addRow = this.addRow.bind(this)
        this.deleteRow = this.deleteRow.bind(this)
    }

    togglePopup(){
        this.setState({
            status : "",
            showpopup : false
        })
        window.location.reload()
    }


    onScenarioGroupNameChange(e){
        this.setState({
            scenario_group_name : e.target.value
        })
    }

    onScenarioIdChange(e, index){
        //this.state.scenario_id[this.state.count]= e.target.value
        //Do not mutate state directly. Use setState().
        // this.state.scenario_id[index]= parseInt(e.target.value)
        const {scenario_id} = this.state;
        const alteredScenarioId =  scenario_id.map((item, arrayIndex) => {
            if(index === arrayIndex){
                return parseInt(e.target.value);
            }
            return item;
        })
        this.setState((prevState) => {
            return {
                ...prevState,
                scenario_id : alteredScenarioId
            }
        })
        this.setState({
            scenario_id : this.state.scenario_id
        })
    }

    onScenarioUuidChange(e, index){
        //this.state.scenario_uuid[this.state.count]= e.target.value
        // this.state.scenario_uuid[index]= e.target.value.trim()
        const {scenario_uuid} = this.state;
        const alteredScenarioUuid =  scenario_uuid.map((item, arrayIndex) => {
            if(index === arrayIndex){
                return e.target.value.trim();
            }
            return item;
        })
        this.setState((prevState) => {
            return {
                ...prevState,
                scenario_uuid : alteredScenarioUuid
            }
        })
        this.setState({
            scenario_uuid : this.state.scenario_uuid
        })
    }

    onSequenceNoChange(e, index){
        //this.state.sequence_no[this.state.count] = e.target.value
        // this.state.sequence_no[index] = parseInt(e.target.value)
        const {sequence_no} = this.state;
        const alteredSequence =  sequence_no.map((item, arrayIndex) => {
            if(index === arrayIndex){
                return parseInt(e.target.value);
            }
            return item;
        })
        this.setState((prevState) => {
            return {
                ...prevState,
                sequence_no : alteredSequence
            }
        })
        this.setState({
            sequence_no : this.state.sequence_no
        })
    }


    onSubmiting(){
        console.log("whole data : ", this.state)
        const url = (window.location.origin).concat('/add')
        const data_for_addition ={
            scenario_group_name : this.state.scenario_group_name,
            //scenario_uuid : this.state.scenario_uuid,
            //scenario_id : parseInt(this.state.scenario_id),
            //sequence: parseInt(this.state.sequence_no)
            scenario_id : this.state.scenario_id,
            scenario_uuid : this.state.scenario_uuid,
            sequence : this.state.sequence_no,
        }
        console.log(url)
        console.log(data_for_addition)

        addScenario(url, data_for_addition).then(res => {
            console.log("response after addition : ", res['data']['status'])
            this.setState({
                status : res['data']['status'],
                showpopup : !this.state.showpopup
            })
        })

        this.setState({
            scenario_group_name : "",
            scenario_id : [],
            scenario_uuid : [""],
            sequence_no : [],
        })
    }

    addRow(){
        this.setState((prevState) =>({
            rows : [...prevState.rows, {scene_id:"", scene_uuid:"", seq_id:""}],
            count : this.state.count +1
        }));
        console.log(this.state.rows)
    }

    deleteRow(){
    this.state.rows.pop()
    this.setState({
        rows : this.state.rows,
        count : this.state.count-1
    })
    }

    render(){
        return(
            <div data-test = 'addScenarioGroupComponent' className="container-fluid">
               <div className="row">
                  <div className="col mt-5 mx-auto">
                    <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card">
                            <h2 className="card-header" style={{ color:"white" , fontSize: "100% !important", backgroundColor : "#757AF7"}}> Add Scenario in  Scenario Group </h2>
                        </div>
                    <div className="card-body">
                        <div className="container">
                            <div className="row">
                                <div className="col-6 text-center">
                                    <button type="button" className="btn" value="Add Scenario" onClick={this.addRow}>Add Scenario</button>
                                </div>
                                <div className="col-6 text-center">
                                    <button type="button" className="btn" value="Delete Scenario" onClick={this.deleteRow}>Delete Scenario</button>
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: "3%" }}>
                                <div className="col-3"></div>
                                <div className="col-6">
                                    <form onChange={this.handleChange}>
                                        <div className="form-group">
                                            <label htmlFor="group_name" style={{ color: "#464646", fontSize: "100%", fontWeight: "bold"}} >Scenario Group Name </label>
                                            <input type="text" className="form-control" list="data" value={this.state.scenario_group_name}
                                                onChange={this.onScenarioGroupNameChange} placeholder="Select Scenario Group/Create new"/>
                                                 <datalist id="data">
                                                     <option value="Highway"/>
                                                     <option value="City"/>
                                                     <option value="Rural"/>
                                                     <option value="Lane_Change"/>
                                                 </datalist>
                                        </div>
                                        <div className="form-group">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Scenario Id</label></th>
                                                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Scenario UUID </label></th>
                                                        <th scope="col"><label htmlFor="group_name" className="col-form-label" style={{ color: "#464646"}} >Sequence Number</label></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rows.map((val, index) => {
                                                            return (
                                                                <tr key={"row"+index}>
                                                                <td>
                                                                    <input type="text" className="form-control" id={"scenario_id"+index} placeholder="Scenario_Id"
                                                                      classNameB="scene_id" onChange={(e)=>{this.onScenarioIdChange(e,index)}}/>
                                                                </td>
                                                                <td>
                                                                     <input type="text" className="form-control" id={"scenario_uuid"+index} placeholder="Scenario_uuid"
                                                                       classNameB="scene_uuid" onChange={(e)=>{this.onScenarioUuidChange(e,index)}}/>
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" id={"sequence_no"+index} placeholder="Sequence Number"
                                                                        classNameB="seq_no" onChange={(e)=>{this.onSequenceNoChange(e,index)}}/>
                                                                </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                                </table>
                                        </div>
                                        <div className="form-group text-center">
                                            <button type="button" className="btn" onClick={this.onSubmiting}>Submit</button>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-3"></div>
                        </div>
                        </div>
                    </div>
                </div>
                {this.state.showpopup ? <PopupModal text={this.state.status} closePopup={this.togglePopup.bind(this)} />: ""}
                </div>
            </div>
        </div>
        )
    }
}
// onScenarioUuidChange(e, index){
//     //this.state.scenario_uuid[this.state.count]= e.target.value
//     this.state.scenario_uuid[index]= e.target.value.trim()
//     this.setState({
//         scenario_uuid : this.state.scenario_uuid
//     })
// }

// onSequenceNoChange(e, index){
//     //this.state.sequence_no[this.state.count] = e.target.value
//     this.state.sequence_no[index] = parseInt(e.target.value)
//     this.setState({
//         sequence_no : this.state.sequence_no
//     })
// }


// onSubmiting(){
//     console.log("whole data : ", this.state)
//     const url = (window.location.origin).concat('/add')
//     const data_for_addition ={
//         scenario_group_name : this.state.scenario_group_name,
//         //scenario_uuid : this.state.scenario_uuid,
//         //scenario_id : parseInt(this.state.scenario_id),
//         //sequence: parseInt(this.state.sequence_no)
//         scenario_id : this.state.scenario_id,
//         scenario_uuid : this.state.scenario_uuid,
//         sequence : this.state.sequence_no,
//     }
//     console.log(url)
//     console.log(data_for_addition)

//     addScenario(url, data_for_addition).then(res => {
//         console.log("response after addition : ", res['data']['status'])
//         this.setState({
//             status : res['data']['status'],
//             showpopup : !this.state.showpopup
//         })
//     })

//     this.setState({
//         scenario_group_name : "",
//         scenario_id : [],
//         scenario_uuid : [""],
//         sequence_no : [],
//     })
// }

// addRow(){
//     this.setState((prevState) =>({
//         rows : [...prevState.rows, {scene_id:"", scene_uuid:"", seq_id:""}],
//         count : this.state.count +1
//     }));
//     console.log(this.state.rows)
// }

// deleteRow(){
// this.state.rows.pop()
// this.setState({
//     rows : this.state.rows,
//     count : this.state.count-1
// })
// }

export default AddScenario
